export default "__VITE_ASSET__ClBnaf_w__"